/**
 * Scoutside App Delivery & Pickup Date/Rate Picker
 * ------------------------------------------------------------------------------
 *
 * Makes an Asynchronous call to the Scoutside Application Server to retrieve information
 * about Delivery Rates, Blackout Dates, Pickup Locations, etc.
 * This info will be filtered into an array of dates to be displayed with selectable rates.
 * The Selected date will be sent back to the Server to apply the appropriate filters for
 * The Scoutside Carrier Calculated Shipping.
 *
 */

 /**
 * Helps to format Dates input single d, outputs dd.
 * ie. addZ(2) => '02'
 */
 function addZ (n) {return n<10? '0'+n:''+n;}

 function isValidUSZip(sZip) {
   return /^\d{5}(-\d{4})?$/.test(sZip);
}

/**
* Helps to format Money
* ie. convertWithDollarToMoney('$9') => 9000
* @param: String
* @returns: Number
*/
 function convertWithDollarToMoney(dollarString) {
   return (Number(dollarString.split('$')[1]) * 100);
}

/**
* Helps to format Money to fixed decimal
* ie. convertMoneyToString(9000) => '$9.00'
* @param: Number
* @returns: String
*/
 function convertMoneyToString(money) {
   return (money / 100).toFixed(2);
}

 function formatDate(str) {
  var d = new Date(str)
  var date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds()));
  var options = {
    weekday: "short", year: "numeric",
    month: "long", day: "numeric"
  };

  return date.toLocaleDateString("en-us", options)
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

var Scoutside = Scoutside || {};
// TODO: need to add some error handling if there are no dates
Scoutside.RatePicker = {
  monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  weekNames: ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
  settingsDefaults: {
      admin: false,
      sub_cart_items: [],
      deliveryDate: "",
      shippingRates: [],
      blackoutDates: [],
      chargeDatesUpdated: false,
      cartTotalPrice: null,
      elementSelector: "*[data-toggle='ratepicker']",
      dateInputSelector: "*[data-toggle='deliveryDate']",
      rateInputSelector: "*[data-toggle='rate']",
      receiveWindowInputSelector: "*[data-toggle='receiveWindow']",
      shipmentDateInputSelector: "*[data-toggle='shipmentDate']",
      checkoutMethodInputSelector: "*[data-toggle='checkoutMethod']",
  },
  initialize: function(options) {
    if (options) {
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          Scoutside.RatePicker.settingsDefaults[prop] = options[prop]
        }
      }
    }
  },
  render: function(methodString) {

    var settings = Scoutside.RatePicker.settingsDefaults;
    var $ratePickerContainer = $(settings.elementSelector);
    $ratePickerContainer.html('')

    var Ratefrag = document.createDocumentFragment();

    var rateDIV = document.createElement("DIV");
    rateDIV.classList.add('time-rates');
    rateDIV.innerHTML = Scoutside.RatePicker.createRatesHtml(settings[methodString]);
    Ratefrag.appendChild(rateDIV);

    $ratePickerContainer.append(Ratefrag);
  },
  checkRateMinMax: function(rate) {
    if ( !Scoutside.RatePicker.settingsDefaults.admin ) {

      var cartTotal = Scoutside.RatePicker.settingsDefaults.cartTotalPrice * 100

      if (rate.min_price !== null && rate.max_price !== null) {
        return cartTotal >= rate.min_price && cartTotal <= rate.max_price
      } else if (rate.min_price) {
        return cartTotal >= rate.min_price
      } else if (rate.max_price) {
        return cartTotal <= rate.max_price
      } else {
        return true
      }

    } else  {
      return true
    }
  },
  disableCheckout: function() {
    var checkoutProxy = document.querySelector('.checkout_proxy');
    checkoutProxy.setAttribute("disabled", true);
    checkoutProxy.classList.add('disabled');
  },
  enableCheckout: function() {
    var checkoutProxy = document.querySelector('.checkout_proxy');
    checkoutProxy.disabled = false
    checkoutProxy.classList.remove('disabled');
  },
  createRatesHtml: function(rates) {
    var deliveryDate = Scoutside.RatePicker.settingsDefaults['deliveryDate'] === "" ? "" : new Date(Scoutside.RatePicker.settingsDefaults['deliveryDate']);

    var rates = rates.map(function(rate, i) {
      var shipmentDate = rate.shipment_date === undefined ? "" : new Date(rate.shipment_date.split('-').join('/'));

      var disabled = rate.disabled;
      var data = "data-id='"+ rate.id +"' data-date='"+ deliveryDate + "' data-checkout-method='" + rate.delivery_method + "' data-shipment-date='" + shipmentDate + "' data-receive-window='" + (rate.receive_window ? rate.receive_window : '') + "' data-rate='[" + rate.id + "] " + rate.title + "'";
      var titleString = "<h6 class='title'>" + rate.title + "</h6>";
      var descriptionString = "<span class='description'>" + rate.description + "</span>";
      var priceString = "<span class='price'>$" + ( rate.price / 100 ) + "</span>";
      var iconString = "<img class='icon' src='" + rate.icon_url + "'>";
      var titleDescription = "<div class='icon-title-container'>" + priceString + titleString + "<div class='rate-description'>" + descriptionString + "</div>" + "</div>"
      var btn = "<div class='select-btn button btn btn--clear " + (disabled ? "disabled" : "") + "'><span>" + (disabled ? "Unavailable" : "Select") + "</span></div>";
      var rateString = "<div " + data + " class='rate " + (disabled ? "disabled" : "") + "'>" + iconString + titleDescription + btn + "</div>";

      return rateString
    }).join('')
    return rates
  },
  getSubCartItems: function() {
    // Grab data for cart items that are subscriptions
    // These will need to have 'charge_on_day_of_week' property updated based on delivery/pickup date picked.
    $.getJSON("/cart", function(data) {
      Scoutside.RatePicker.settingsDefaults.sub_cart_items = data.items.filter(function(item,i){
        if (item.properties !== null) {
          if(!!item.properties["subscription_id"]) {
            item.line_number = i
            return item
          }
        }
      })
    })
  },
  addRateId: function(rechargeDeliveryDelay, rate_id, cart_items, checkoutMethod, sendToCheckoutCallback) {
    console.log("cart_items", cart_items, cart_items.length);
    console.log("cart_items", typeof cart_items);
    var data = function(item, index) {
      return {
        line: (index + 1),
        properties: item.properties,
        quantity: Number(item.quantity)
      }
    };

    var oneDay = 24*60*60*1000;
    var deliveryDate = new Date($(Scoutside.RatePicker.settingsDefaults.dateInputSelector).val());
    var today = new Date((new Date()).toLocaleDateString())
    var diffDays = Math.round(Math.abs((today.getTime() - deliveryDate.getTime())/(oneDay)));

    Shopify.queue = []

    cart_items.forEach(function(item, idx, arr) {
      if (item.properties !== null) {
        if(!!item.properties["subscription_id"]) {
          item.properties === null ? item.properties = {} : null;
          item.properties["charge_delay"] = (item.properties["shipping_interval_frequency"] * 7) + diffDays - rechargeDeliveryDelay
        }
      }
      console.log("item:", item);
      console.log("item:", item.properties);
      item.properties === null ? item.properties = {} : null;
      item.properties["_Delivery rate id"] = rate_id.split(']')[0].split('[')[1]
      Shopify.queue.push(data(item, idx));
    })

    console.log("Shopify.queue:", Shopify.queue);

    Shopify.moveAlong = function() {
      // If we still have requests in the queue, let's process the next one.
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();

        CartJS.updateItem(
          request.line,
          request.quantity,
          request.properties, {
          "success": function(data, textStatus, jqXHR){Shopify.moveAlong()},
          "error": function(jqXHR, textStatus, errorThrown){console.log("err", errorThrown);}
        })
      }
      // If the queue is empty, we will redirect to the checkout page.
      else {
        console.log("last change");
        sendToCheckoutCallback();
      }
    };

    console.log("Shopify.queue[0]", Shopify.queue[0]);

    CartJS.updateItem(
      Shopify.queue[0].line,
      Shopify.queue[0].quantity,
      Shopify.queue[0].properties, {
      "success": function(data, textStatus, jqXHR){ Shopify.moveAlong()},
      "error": function(jqXHR, textStatus, errorThrown){console.log("err", errorThrown);}
    })
  },
  resetDateRate: function() {
    Scoutside.RatePicker.disableCheckout();

    var rateInput = $(Scoutside.RatePicker.settingsDefaults.rateInputSelector);
    var dateInput = $(Scoutside.RatePicker.settingsDefaults.dateInputSelector);

    $('.shipping-line').text("$0.00");
    $('.total-price').text('$' + (CartJS.cart.total_price / 100).toFixed(2));
    rateInput.val("");
    dateInput.val("");
  },
  resetRate: function() {
    Scoutside.RatePicker.disableCheckout();
    var rateInput = $(Scoutside.RatePicker.settingsDefaults.rateInputSelector);

    $('.shipping-line').text("$0.00");
    $('.total-price').text('$' + (CartJS.cart.total_price / 100).toFixed(2));
    rateInput.val("");
  },
  addListeners: function() {
    $('.method__btn button:not(.keep-shopping)').on('click', function(e){
      e.preventDefault();

      $('.method__btn button:not(.keep-shopping)').each(function(i, el){
        el.textContent = 'Select';
      })
      this.parentElement.parentElement.previousElementSibling.checked = true;
      this.textContent = 'Selected';
    })

    $('.rad input[type="radio"]').change(function(e){

      $('.method__btn button:not(.keep-shopping)').each(function(i, el){
        el.textContent = 'Select';
      })
      $(this.nextElementSibling).find('.method__btn button:not(.keep-shopping)').text('Selected');
    })

    var $rate = $('.rate:not(.disabled)');

    $rate.each(function(i, rate) {
      $(rate).on('click', function(evt) {
        $rate.each(function(i, r) {
          $(r).removeClass('selected');
          $(r).find('.button span').text('select');
        })
        var shippingPrice = convertWithDollarToMoney($(this).find('.price').text());

        $(this).toggleClass('selected');
        $(this).find('.button span').text('selected');
        $(Scoutside.RatePicker.settingsDefaults.dateInputSelector).val(formatDate($(this).attr('data-date')));
        $(Scoutside.RatePicker.settingsDefaults.rateInputSelector).val($(this).attr('data-rate'));
        $('.shipping-line').text('$' + convertMoneyToString(shippingPrice));
        $('.total-price').text('$' + convertMoneyToString(CartJS.cart.total_price + shippingPrice));
        $(Scoutside.RatePicker.settingsDefaults.receiveWindowInputSelector).val($(this).attr('data-receive-window'));
        $(Scoutside.RatePicker.settingsDefaults.shipmentDateInputSelector).val(formatDate($(this).attr('data-shipment-date')));
        $(Scoutside.RatePicker.settingsDefaults.checkoutMethodInputSelector).val($(this).attr('data-checkout-method'));
        Scoutside.RatePicker.enableCheckout();
      })
    })

  },
  activateDatePicker: function(admin, blackoutDates, nonDeliveryDays, disableBefore, disableAfter, callback_url) {

    $('[data-toggle="datepicker"]').datepicker({
      inline: true,
      autoPick: false,
      container: ".container-datepicker",
      startDate: (disableBefore !== null ? new Date(disableBefore): null),
      endDate: (disableAfter !== null ? new Date(disableAfter) : null),
      filter: function(date) {
        var formattedDate = addZ(date.getMonth() + 1) + '/' + addZ(date.getDate()) + '/' +  date.getFullYear()
        var wday = date.getDay()
        // disable deliverys dates based on non-operation days and blackouts
        if (nonDeliveryDays.includes(wday)) {
          return false;
        }
        if (blackoutDates.includes(formattedDate)) {
          return false;
        }
      },
      pick: function(date) {
        $('[data-view="day picked"]').addClass('picked');
        Scoutside.RatePicker.resetDateRate();
        var dateString = new Date(date.date);
        var today = new Date();

        if (dateString.toLocaleDateString() !== today.toLocaleDateString()) {
          $.ajax({
            type: "GET",
            contentType: "application/json; charset=utf-8",
            url: callback_url.concat("&date=" + dateString + "&cart_total=" + CartJS.cart.total_price ),
                   success: function(res) {
                     // Show rate picker
                     $('.cart-ratepicker').show();
                     Scoutside.RatePicker.initialize({
                       shippingRates: res.shippingRates,
                       deliveryDate: dateString,
                       admin: admin,
                     });
                     disabledRates = [];
                     enabledRates = [];
                     res.shippingRates.forEach(function(rate, index){
                       if (!rate.title.toLowerCase().includes('free')) {
                          rate.disabled === true ? disabledRates.push(rate.price) : enabledRates.push(rate.price)
                       }
                     });
                     if (Math.min.apply(null, disabledRates) < Math.min.apply(null, enabledRates)) {
                       $('.cheaper-rate').show();
                     } else {
                       $('.cheaper-rate').hide();
                     }
                   },
                   error: function(res) {
                     console.log("error", res);
                   }
          }).then(function(res){
            Scoutside.RatePicker.render('shippingRates');
            Scoutside.RatePicker.addListeners();
            $('.cart-ratepicker').fadeIn().removeClass('hide');
          })
        }
      }
    });

    // select today
    // REQUEST: To select no dates on load.
    // $('[data-toggle="datepicker"]').datepicker('setDate', '');
    $('.picked').removeClass('picked');
  }
}
